import React from "react";
import { Mic, Square } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Inline mic button for the composer. Tap once to start recording,
 * tap again to stop. Pulsing terracotta ring while active so the state
 * is unmistakable without adding extra text.
 */
const MicButton = ({ isRecording, onToggle, disabled = false, className }) => (
    <button
        type="button"
        data-testid="btn-voice-input"
        data-recording={isRecording ? "true" : "false"}
        onClick={onToggle}
        disabled={disabled}
        aria-label={isRecording ? "Stop recording" : "Start voice input"}
        aria-pressed={isRecording}
        className={cn(
            "relative inline-flex items-center justify-center h-9 w-9 rounded-full transition-all shrink-0 outline-none",
            "focus-visible:ring-2 focus-visible:ring-primary/40",
            isRecording
                ? "bg-[#F7EBE8] text-[#A35741] border border-[#E7C8C2]"
                : "bg-transparent text-muted-foreground hover:text-foreground hover:bg-muted border border-transparent hover:border-border",
            disabled && "opacity-40 cursor-not-allowed",
            className,
        )}
    >
        {isRecording ? (
            <>
                <Square className="h-3.5 w-3.5 fill-current" />
                <span
                    aria-hidden
                    className="absolute inset-0 rounded-full ring-2 ring-[#A35741]/40 animate-pulse"
                />
            </>
        ) : (
            <Mic className="h-4 w-4" />
        )}
    </button>
);

export default MicButton;
